import { useNavigate } from 'react-router-dom'
import { FEATURES } from '../lib/featureFlags'

// ── FeatureGate ───────────────────────────────────────────────────────────────
// Routes for features the App experience mode has turned off. Used to be a silent
// <Navigate to="/"> — a shared link to /cliffhanger in Basic just bounced to Home
// with no explanation (audit 2026-09-12). Now it's the unlock: one card, one tap,
// and the feature is on for this account (Basic → Custom with just that key).
export function FeatureGate({ featureKey, featureFlags, children }) {
  const navigate = useNavigate()
  const enabled = !featureKey || !featureFlags || featureFlags.isEnabled(featureKey)
  if (enabled) return children
  const f = FEATURES.find(x => x.key === featureKey)
  return (
    <div style={{ minHeight:'70dvh', display:'flex', alignItems:'center', justifyContent:'center', padding:24, fontFamily:'var(--font)' }}>
      <div style={{ maxWidth:360, width:'100%', textAlign:'center' }}>
        <div style={{ fontFamily:'var(--font-mono)', fontSize:10.5, letterSpacing:'0.12em', textTransform:'uppercase', color:'var(--amber)' }}>Off right now</div>
        <div style={{ color:'var(--text-strong)', fontFamily:'var(--font-serif)', fontWeight:500, fontSize:28, lineHeight:1.1, marginTop:6 }}>{f?.label || 'This feature'}</div>
        <div style={{ color:'var(--text-muted)', fontSize:14, lineHeight:1.5, margin:'10px 0 18px' }}>
          {f?.desc ? `${f.desc}. ` : ''}You’re on the simple tracker. Turn this one on and nothing else changes; every switch lives in Settings → Features.
        </div>
        <button onClick={() => featureFlags.unlockFeature(featureKey)} className="ui-primary" style={{ width:'100%', height:46, background:'var(--amber)', color:'var(--amber-ink)', border:'none', borderRadius:'var(--radius-pill)', fontWeight:600, fontSize:15, cursor:'pointer', fontFamily:'var(--font)' }}>
          Turn on {f?.label || 'it'}
        </button>
        {featureFlags?.setMode && <button onClick={() => featureFlags.setMode('advanced')} style={{ marginTop:10, width:'100%', height:40, background:'var(--bg-card)', color:'var(--text)', border:'1px solid var(--border)', borderRadius:'var(--radius-pill)', fontWeight:600, fontSize:14, cursor:'pointer', fontFamily:'var(--font)' }}>
          Turn everything on
        </button>}
        <button onClick={() => navigate('/', { replace: true })} style={{ marginTop:8, background:'none', border:'none', color:'var(--text-dim)', fontSize:12.5, fontWeight:600, cursor:'pointer', fontFamily:'var(--font)', padding:'8px' }}>
          Back to Home
        </button>
      </div>
    </div>
  )
}
